<template>
  <div class="row">
    <div class="flex xs10 offset--xs1">
      <va-card :title="title">
        <div class="row">
          <div class='flex md12 sm6 xs12'>
            <va-button
              outline
              color="success"
              @click="translateUnfilledFields"
            >一件翻译绿色Field</va-button>
          </div>
          <div class='flex md4 sm6 xs12'>
            <va-input
              v-model='insertData.id'
              v-show="showId"
              label='id'
              disabled
            />
          </div>
          <div class='flex md4 sm6 xs12'>
            <va-input
              v-model='insertData.courseId'
              v-show="showUid"
              label='唯一标识'
              disabled
            />
          </div>
          <div class='flex md4 sm6 xs12'>
            <va-input
              v-model='insertData.views'
              v-show="showViews"
              label='学习人数'
              disabled
            />
          </div>

          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.name"
              label="课程名称"
              :placeholder="placeholders.name"
              removable
              :messages="message"
              :error="!!error.nameErrors.length"
              :error-messages="error.nameErrors"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.nameEn"
              label="课程名称(英文)"
              :placeholder="placeholders.nameEn"
              removable
              :messages="message"
              :error="!!error.nameEnErrors.length"
              :error-messages="error.nameEnErrors"
              success
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-select
              label="课程标签"
              v-model="insertData.courseTagIds"
              multiple
              :options="computedTags"
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-select
              label="导师"
              v-model="insertData.mentorUids"
              multiple
              searchable
              :options="computedMentors"
            />
          </div>
          <div class='flex md12 sm6 xs12' v-show="insertData.imgUrl.length!==0">
            <va-card
              overlay
              :image='insertData.imgUrl'
              class="va-card-image"
            >
            </va-card>
          </div>
          <div class='flex md12 sm6 xs12'>
            <va-card title='封面图'>
              <va-file-upload
                type='single'
                v-model='insertData.imgUrlArr'
                @input="uploadImage"
              />
            </va-card>
          </div>
          <div class="flex md4 sm6 xs12">
            <va-select
              label="状态"
              v-model="insertData.status"
              :options="statusOptions"
              :messages="message"
              :error="!!error.statusErrors.length"
              :error-messages="error.statusErrors"
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              v-model="insertData.sortNum"
              label="排序"
              placeholder="数字越大越靠前"
              removable
              type="number"
              :min="1"
              oninput="if(value<1)value=1"
              :messages="message"
              :error="!!error.sortNumErrors.length"
              :error-messages="error.sortNumErrors"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <div class="d-flex justify--end">
              <va-button  color="primary" slot="trigger" @click="clickSubmit" :disabled="!submitButtonStatus">
                保存
              </va-button>
            </div>
          </div>
          <div class="flex md6 sm6 xs12">
            <div class="d-flex justify--start">
              <va-button  color="gray" slot="trigger" @click="$router.push({ name: 'listFreeOpenCourse'})" :disabled="!submitButtonStatus">
                返回
              </va-button>
            </div>
          </div>

        </div>

      </va-card>
    </div>
    <div class="flex xs10 offset--xs1">
      <va-card title="视频列表" v-show="showVideos">
        <div class="row align--center mb-1">
          <div class="flex xs12 sm12">
            <div class="d-flex justify--end">
              <va-button color="info" small :to="{ name: 'saveVideo', query: {serviceId: insertData.id, serviceType: 1} }">新增视频</va-button>
            </div>
          </div>
        </div>
        <va-data-table
          :fields="fields"
          :data="insertData.videos"
          :loading="loading"
          api-mode
        >
          <!--  排序  -->
          <template slot="sort" slot-scope="props">
            <va-input
              v-model="props.rowData.sortNum"
              type="number"
              :min="1"
              v-bind:style="{marginTop: '1rem', width: '50%'}"
            >
              <va-button slot="append" icon="ion-md-checkmark ion" color="info" small @click="updateVideoSortNum(props.rowData)">
              </va-button>
            </va-input>
          </template>
          <template slot="actions" slot-scope="props">
            <va-button flat small color="gray" icon="fa fa-pencil"
              :to='{path:`/admin/video/updateVideo/${props.rowData.videoId}`}'/>
            <va-button flat small color="gray" icon="fa fa-trash"
              @click="deleteModal = true;deleteUid=props.rowData.videoId"/>
          </template>
        </va-data-table>
        <va-modal
          v-model="deleteModal"
          title="删除视频"
          okText="提交"
          position="center"
          message="请再次确认是否要删除？"
          @ok="confirmDeleteVideo"
        />
      </va-card>
    </div>
  </div>
</template>

<script>

import 'vue-trix'
import uploadApi from '../../../api/upload'
import freeOpenCourseApi from '../../../api/freeOpenCourse'
import { copyObject, formatTime, translateData } from '../../../utils/common'
import mentorApi from '../../../api/mentor'
import videoApi from '../../../api/video'
import tagApi from '../../../api/tag'
import { TAG_TYPE } from '../../../utils/constants'

export default {
  data () {
    return {
      insertData: {
        id: null,
        courseId: '',
        name: '',
        nameEn: '',
        imgUrl: '',
        imgUrlArr: [],
        views: null,
        status: '草稿中',
        sortNum: 1,
        courseTagIds: [],
        mentorUids: [],
        videos: [],
      },
      placeholders: {
        name: '例: 基于人工智能的消费者感情分析',
        nameEn: 'Example: Consumer sentiment analysis based on artificial intelligence',
      },
      message: ['Required field'],
      courseTags: [],
      mentors: [],
      error: {
        nameErrors: [],
        nameEnErrors: [],
        sortNumErrors: [],
        statusErrors: [],
      },
      showId: false,
      showUid: false,
      showViews: false,
      deleteModal: false,
      showVideos: false,
      deleteUid: null,
      loading: true,
      title: '新增免费公开课',
      statusOptions: ['草稿中', '已发布', '已下架'],
      submitButtonStatus: true,
    }
  },
  created () {
    this.getFreeOpenCourse()
    this.listCourseTag()
    this.listMentor()
  },
  computed: {
    fields () {
      return [
        {
          name: '__slot:sort',
          title: '排序',
          width: '20%',
        },
        {
          name: 'videoName',
          title: '视频名称',
          width: '20%',
        },
        {
          name: 'duration',
          title: '视频时长',
          width: '15%',
        },
        {
          name: 'videoId',
          title: 'videoId',
          width: '15%',
        },
        {
          name: 'createTime',
          title: '创建时间',
          width: '15%',
        },
        {
          name: '__slot:actions',
          width: '14%',
          dataClass: 'text-left',
        },
      ]
    },
    formReady () {
      return !this.error.nameErrors.length &&
          !this.error.nameEnErrors.length &&
          !this.error.sortNumErrors.length &&
          !this.error.statusErrors.length
    },
    computedTags () {
      return this.courseTags.map(x => {
        return x.name
      })
    },
    flipTags () {
      const flipTags = {}
      this.courseTags.forEach(x => {
        flipTags[x.name] = x.id
      })
      return flipTags
    },
    computedMentors () {
      return this.mentors.map(x => {
        return x.nickname + '(' + x.uid + ')'
      })
    },
    flipMentors () {
      const flipMentors = {}
      this.mentors.forEach(x => {
        flipMentors[x.nickname + '(' + x.uid + ')'] = x.uid
      })
      return flipMentors
    },
  },
  methods: {
    getFreeOpenCourse () {
      const params = this.$route.params
      if (params.id != null) {
        this.showId = true
        this.showUid = true
        this.showViews = true
        this.showVideos = true
        this.title = '编辑免费公开课'
        // 通过id获取详情
        freeOpenCourseApi.getFreeOpenCourse(params.id).then(response => {
          copyObject(response.freeOpenCourse, this.insertData)
          // eslint-disable-next-line no-prototype-builtins
          if (response.freeOpenCourse.hasOwnProperty('status')) {
            if (response.freeOpenCourse.status === 0) {
              this.insertData.status = '草稿中'
            } else if (response.freeOpenCourse.status === 1) {
              this.insertData.status = '已发布'
            } else {
              this.insertData.status = '已下架'
            }
          }
          // eslint-disable-next-line no-prototype-builtins
          if (response.hasOwnProperty('courseTags') && response.courseTags.length !== 0) {
            const that = this
            that.insertData.courseTagIds = []
            response.courseTags.forEach(x => {
              that.insertData.courseTagIds.push(x.name)
            })
          }
          // eslint-disable-next-line no-prototype-builtins
          if (response.hasOwnProperty('mentors') && response.mentors.length !== 0) {
            const that = this
            that.insertData.mentorUids = []
            response.mentors.forEach(x => {
              that.insertData.mentorUids.push(x.nickname + '(' + x.uid + ')')
            })
          }
          // eslint-disable-next-line no-prototype-builtins
          if (response.hasOwnProperty('videos') && response.videos.length !== 0) {
            const that = this
            that.insertData.videos = []
            response.videos.forEach(x => {
              x.createTime = formatTime(x.createTime)
              that.insertData.videos.push(x)
            })
          } else {
            const that = this
            that.insertData.videos = []
          }
          this.loading = false
        }).catch(error => {
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    listMentor () {
      const params = {
        pageNumber: 1,
        pageSize: 1000,
      }
      mentorApi.listMentor(params).then(response => {
        this.mentors = response.mentors
      }).catch(error => {
        console.log(error)
      })
    },
    listCourseTag () {
      tagApi.listTag({ tagType: TAG_TYPE.COURSE_TAG.CODE }).then(response => {
        this.courseTags = response.tags
      }).catch(error => {
        console.log(error)
      })
    },
    clickSubmit () {
      this.checkField()
      if (!this.formReady) {
        return
      }
      if (this.insertData.imgUrl.length === 0) {
        this.showToast('有图片未上传，请请检查后重试！', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
        return
      }
      this.changeButtonStatus(false)
      const data = {
        name: this.insertData.name,
        nameEn: this.insertData.nameEn,
        courseId: this.insertData.courseId,
        views: this.insertData.views,
        imgUrl: this.insertData.imgUrl,
        sortNum: this.insertData.sortNum !== null ? this.insertData.sortNum : 1,
        courseTagIds: this.insertData.courseTagIds.map(tagName => {
          return this.flipTags[tagName]
        }),
        mentorUids: this.insertData.mentorUids.map(nicknameWithUid => {
          return this.flipMentors[nicknameWithUid]
        }),
      }
      if (data.courseTagIds == null) {
        data.courseTagIds = []
      }
      if (this.insertData.status === null || this.insertData.status === '草稿中') {
        data.status = 0
      } else if (this.insertData.status === '已发布') {
        data.status = 1
      } else {
        data.status = 2
      }

      if (this.insertData.id != null) {
        data.id = this.insertData.id
        freeOpenCourseApi.updateFreeOpenCourse(data.id, data).then(response => {
          if (response.success === true) {
            this.showToast('更新免费公开课成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.getFreeOpenCourse(this.$route.params.id)
            this.changeButtonStatus(true)
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      } else {
        freeOpenCourseApi.saveFreeOpenCourse(data).then(response => {
          if (response.success === true) {
            this.showToast('添加免费公开课成功, 请上传视频', {
              duration: 5000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.showVideos = true
            this.loading = false
            this.$router.push({ name: 'updateFreeOpenCourse', path: `updateFreeOpenCourse/${response.id}`, params: { id: response.id } })
            this.insertData.id = response.id
            this.getFreeOpenCourse()
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    clickCancel () {
    },
    checkField () {
      this.error.nameErrors = this.insertData.name ? [] : ['name is required']
      this.error.nameEnErrors = this.insertData.nameEn ? [] : ['nameEn is required']
      this.error.sortNumErrors = this.insertData.sortNum ? [] : ['sortNum is required']
      this.error.statusErrors = this.insertData.status ? [] : ['status is required']
    },
    uploadImage () {
      if (this.insertData.imgUrlArr.length === 0) return
      const formData = new FormData()
      formData.append('type', 'image')
      formData.append('file', this.insertData.imgUrlArr[this.insertData.imgUrlArr.length - 1])
      uploadApi.uploadImage(formData).then(response => {
        this.insertData.imgUrl = response.url
        this.showToast('上传图片成功', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
    confirmDeleteVideo () {
      if (this.deleteUid === null) return
      videoApi.deleteVideo(this.deleteUid).then(response => {
        if (response.success === true) {
          this.showToast('删除视频成功', {
            duration: 1000,
            icon: 'fa-check',
            position: 'top-center',
            fullWidth: false,
          })
          this.getFreeOpenCourse()
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    updateVideoSortNum: function (params) {
      const data = {
        uid: params.uid,
        sortNum: params.sortNum,
      }
      videoApi.updateVideo(params.uid, data).then(response => {
        if (response.success === true) {
          this.showToast('更新排序成功', {
            duration: 1000,
            icon: 'fa-check',
            position: 'top-center',
            fullWidth: false,
          })
          this.getFreeOpenCourse()
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    async translateUnfilledFields () {
      // 标题
      if (this.insertData.name !== '' && this.insertData.nameEn === '') {
        this.insertData.nameEn = await translateData(this.insertData.name)
      }
    },
  },
}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
